import React from "react";
import {
  FieldArray as RffFieldArray,
  FieldArrayProps as RffFieldArrayProps,
} from "react-final-form-arrays";
import { FieldValidator } from "final-form";
import { useIntl } from "react-intl";
import type { IntlFormatters } from "@formatjs/intl";

type T = IntlFormatters["formatMessage"];

export type FieldArrayProps = {
  nonZeroArray?: boolean;
};

const nonZeroArrayValidator = (t: T): FieldValidator<Array<any>> => (val) =>
  !val || val.length === 0 ? t({ id: "requiredLabel" }) : undefined;

const FieldArray = ({
  children,
  nonZeroArray,
  ...props
}: FieldArrayProps & RffFieldArrayProps<any, HTMLElement>) => {
  const { formatMessage: t } = useIntl();
  const validate = nonZeroArray ? nonZeroArrayValidator(t) : undefined;

  return <RffFieldArray {...{ ...props, validate }}>{children}</RffFieldArray>;
};

export default FieldArray;
